import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function GreatLocation(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M5 9.923C5 6.677 7.71 4 11.108 4c2.26 0 4.064 1.172 4.925 2.188l-4.993 4.438-1.333-1.333a1 1 0 00-1.414 1.414l2 2a1 1 0 001.371.04l9-8a1 1 0 00-1.328-1.494l-1.808 1.606C16.291 3.424 13.96 2 11.108 2 6.655 2 3 5.523 3 9.923c0 1.441.523 2.906 1.226 4.241.709 1.347 1.642 2.637 2.555 3.75a36.852 36.852 0 003.578 3.758l.065.058.017.015.005.005.002.002a1 1 0 001.319 0l-.66-.752.66.751h.002l.004-.005.014-.012.053-.047.192-.175a37.878 37.878 0 002.831-2.923c1.591-1.833 3.448-4.361 4.104-6.86a1 1 0 00-1.934-.508c-.533 2.027-2.122 4.261-3.68 6.058a35.894 35.894 0 01-2.245 2.358 34.85 34.85 0 01-2.781-2.993c-.864-1.051-1.708-2.227-2.332-3.412C5.365 12.036 5 10.905 5 9.923zM11.108 21l-.66.752.66-.752z",
    clipRule: "evenodd"
  }));
}

export default GreatLocation;